import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { OfferCustomerResponse, OfferCustomerPayload } from '../../models/offerCustomerGenerated.model';

@Injectable({
  providedIn: 'root'
})
export class ApiCDCService {

  constructor(private http: HttpClient, private apiService: ApiService) { }

  apiUrl = `${this.apiService.apiUrl}/api`;

  createOfferForCustomer(customerId: string, offerData: OfferCustomerPayload): Observable<OfferCustomerResponse> {
    return this.http.post<OfferCustomerResponse>(`${this.apiUrl}/v1/customers/${customerId}/offers`, offerData);
  }
}
